import React from 'react';
import useThrottledReload from '../hooks/useThrottledReload';

// Installed as a mobile web app, the page has no browser chrome and no
// pull-to-refresh (index.css locks page scroll/overscroll to stop the mobile
// scroll-wobble bug — see .no-page-scroll — which also disables the native
// gesture), so this is the only way to force a reload on mobile.
function RefreshButton({ className, children }) {
  const { ready, secondsRemaining, refresh } = useThrottledReload();
  return (
    <button
      type="button"
      onClick={refresh}
      disabled={!ready}
      className={`${className} ${!ready ? 'opacity-40 cursor-not-allowed' : ''}`}
      aria-label={ready ? 'Refresh the page' : `Refresh again in ${secondsRemaining}s`}
      title={ready ? 'Refresh' : `Wait ${secondsRemaining}s`}
    >
      <i className="fas fa-arrows-rotate text-sm" aria-hidden="true"></i>
      {children}
    </button>
  );
}

export default RefreshButton;
